module.exports = __webpack_public_path__ + "img/SER-A-3-V.4dbb11c2.png";